<div class="domestic-fields-container">
    <!-- City -->
    <mm-text-input-control class="medium-bottom-spacer" id="checkTransactionDetails_city" [parentForm]="parentForm"
        [inputControlModel]="cityModel" [errorMessage]="cityError" >
    </mm-text-input-control>

    <!-- State and ZIP -->
    <div class="row state-zip-container">
        <div class="column small">
            <mm-select-dropdown-control id="checkTransactionDetails_stateListDropdown" [parentForm]="parentForm"
                [selectModel]="stateListDropdown" class="big-bottom-spacer" [showSelectOne]="false"
                [showBlankOption]="true">
            </mm-select-dropdown-control>
        </div>
        <div class="column large">
            <mm-text-input-control class="big-bottom-spacer" id="checkTransactionDetails_zipCode"
                [parentForm]="parentForm" [inputControlModel]="zipCodeModel" [errorMessage]="zipCodeError">
            </mm-text-input-control>
        </div>
    </div>
</div>
